import React from "react";
import { DETECTOR_LIMITS, REQUIRED_POSE_LANDMARKS } from "../lib/swingDetector";

const CONNECTIONS = [
  [11, 12],
  [11, 13], [13, 15],
  [12, 14], [14, 16],
  [11, 23], [12, 24], [23, 24],
  [23, 25], [25, 27], [27, 29], [29, 31], [27, 31],
  [24, 26], [26, 28], [28, 30], [30, 32], [28, 32],
];

const DISPLAY_LANDMARKS = [...new Set(CONNECTIONS.flat())];
const REQUIRED_INDICES = new Set(REQUIRED_POSE_LANDMARKS.map(({ index }) => index));

const confidence = (landmark) => landmark?.visibility ?? landmark?.presence ?? 1;
const drawable = (landmark) => landmark && confidence(landmark) >= 0.15;

const PoseOverlay = ({ poses, valid, width = 1280, height = 720 }) => {
  if (!poses?.length) return null;
  const multiple = poses.length > 1;
  const color = valid && !multiple ? "#CCFF00" : "#FFD60A";

  return (
    <svg
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 z-10 h-full w-full camera-pose-overlay"
      data-testid="pose-overlay"
      preserveAspectRatio="xMidYMid slice"
      viewBox={`0 0 ${width} ${height}`}
    >
      {poses.map((landmarks, poseIndex) => (
        <g key={`pose-${poseIndex}`} opacity={multiple ? 0.78 : 1}>
          {CONNECTIONS.map(([startIndex, endIndex]) => {
            const start = landmarks[startIndex];
            const end = landmarks[endIndex];
            if (!drawable(start) || !drawable(end)) return null;
            return (
              <line
                key={`${poseIndex}-${startIndex}-${endIndex}`}
                stroke={color}
                strokeLinecap="round"
                strokeWidth="4"
                vectorEffect="non-scaling-stroke"
                x1={start.x * width}
                x2={end.x * width}
                y1={start.y * height}
                y2={end.y * height}
              />
            );
          })}
          {DISPLAY_LANDMARKS.map((index) => {
            const landmark = landmarks[index];
            if (!drawable(landmark)) return null;
            const requiredAndWeak = REQUIRED_INDICES.has(index)
              && confidence(landmark) < DETECTOR_LIMITS.minimumVisibility;
            return (
              <circle
                key={`${poseIndex}-${index}`}
                cx={landmark.x * width}
                cy={landmark.y * height}
                fill={requiredAndWeak ? "#FF3B30" : color}
                r={requiredAndWeak ? 7 : 5}
                stroke="#0A0A0A"
                strokeWidth="2"
                vectorEffect="non-scaling-stroke"
              />
            );
          })}
        </g>
      ))}
    </svg>
  );
};

export default PoseOverlay;
